import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class OnlineOrderDocumentService {
    constructor(private http: AuthHttp) { }

    getOnlineShipmentOrderDocumentByOrder(ownerCode: string, onlineOrderNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("onlineOrderNo", onlineOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineShipmentOrderDocument/GetOnlineShipmentOrderDocumentByOrder', options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order-document.service.ts